import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/creators/{creatorId}/integrations/{provider}']['POST'];

type Input = ThisApi['params'] & ThisApi['body'];

const upsertCreatorIntegrationAccount = async ({ creatorId, provider, ...body }: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.post(`/creators/${creatorId}/integrations/${provider}`, body);
  return response.data;
};

export default upsertCreatorIntegrationAccount;
